import React from 'react';

import { ProductButtonProps } from '../..';
import { closedFundMessage } from '../../../../../../store/product/normalizer';
import { BatchTicketButton } from '../../components/BatchTicketButton';

export const FundsButton: React.FC<ProductButtonProps<'funds'>> = (props) => {
  const isDisabled = props.offer.closedFundNormalized;
  const tooltip = isDisabled ? closedFundMessage : undefined;

  return (
    <BatchTicketButton
      {...props}
      idSelector="productIdNormalized"
      isDisabled={isDisabled}
      tooltip={tooltip}
    />
  );
};
